<template>
    <NuxtLayout :layout="isLoggedIn ? 'main' : 'auth-new'">
        <div
            class="flex items-center justify-center px-4"
            :class="isLoggedIn
                ? 'h-[calc(100dvh-5rem)] md:h-dvh w-full'
                : 'h-[80vh] md:fixed md:inset-0 md:top-18 md:h-auto md:bg-base-200'"
        >
            <div class="flex flex-col items-center gap-8 w-full max-w-[336px]">
                <IconsErrorRobot class="w-[87px] h-[100px] text-fg-secondary" />

                <div class="flex flex-col gap-4 text-center w-full">
                    <h1 class="text-xl font-semibold leading-7 text-fg-primary">
                        {{ $t("error.title") }}
                    </h1>
                    <p
                        class="text-base font-normal leading-6 text-fg-secondary whitespace-pre-line"
                    >
                        {{ $t("error.description") }}
                    </p>
                </div>

                <div class="flex flex-col gap-4 w-full">
                    <button
                        class="btn w-full rounded-xl bg-green-secondary-1 hover:bg-green-1-hover text-base-contrast-content text-base font-medium leading-6 py-3 px-6 border-none shadow-none"
                        @click="handleRefresh"
                    >
                        {{ $t("error.refreshPage") }}
                    </button>

                    <button
                        v-if="isLoggedIn"
                        class="btn w-full rounded-xl bg-surface-secondary text-fg-primary text-base font-medium leading-6 py-3 px-6 border-2 border-green-secondary-1 hover:bg-green-secondary-1/10 hover:border-green-secondary-1"
                        @click="handleGoHome"
                    >
                        {{ $t("error.goToHome") }}
                    </button>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";
import IconsErrorRobot from "@/components/icons/error-robot.vue";
import useAuth from "@/composables/auth";

defineProps({
    error: {
        type: Object as () => NuxtError,
        default: () => null,
    },
});

const { loggedIn: isLoggedIn } = useAuth();

const handleRefresh = () => window.location.reload();
const handleGoHome = () => clearError({ redirect: "/" });

const { t } = useI18n();

useHead({
    titleTemplate: () => `${t("error.pageTitle")} - Njorda`,
});

const { $intercom } = useNuxtApp();

onMounted(() => {
    $intercom.update({
        hide_default_launcher: true,
    });
});
</script>
